<router-outlet *ngIf="online$ | async; else noInternet"></router-outlet>
<ng-template #noInternet>
    <app-offline></app-offline>
</ng-template>
<app-loader *ngIf="isLoading || !isBrowser"></app-loader>
